module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/3-3cd637dd35d7058d9f22fa6f150d3f52.webm";